import {NgModule} from '@angular/core';
import {YzFloatButtonComponent} from './float-button.component';
import {SharedModule} from "../shared.module";

@NgModule({
  declarations: [
    YzFloatButtonComponent,
  ],
  exports: [
    YzFloatButtonComponent,
  ],
  imports: [
    SharedModule
  ]
})
export class YzFloatButtonModule {
}
